import React, { useState, useEffect, useContext, useRef } from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-cycle
import { PollReportContext } from '../PollsReport';
import QuestionFooter from '../../QuestionFooter';
import QuestionHeader from '../../QuestionHeader';
import SliderChoice from './SliderChoice';
import { perc } from '../PollReportUtils';

function SliderPreview(props) {
  const { question } = props;
  const { questionId, choices, countAnswered, skipSeen } = question;

  const pollReportContext = useContext(PollReportContext);
  const containerReference = useRef();

  const [compareActive, setCompareActive] = useState(false);

  useEffect(() => {
    if (pollReportContext)
      pollReportContext.addReference({ id: questionId, containerReference: containerReference.current });
  }, [pollReportContext, questionId]);

  return (
    <div ref={containerReference} className='c-poll-preview__item'>
      <div className='c-question'>
        <QuestionHeader question={question} onCompareChange={() => setCompareActive(!compareActive)} />

        <div className='c-question__content'>
          <div className='c-result-group'>
            <ul className='c-result-group__items'>
              {choices.map((choice, idx) => (
                <SliderChoice
                  key={idx}
                  compareActive={compareActive}
                  choice={choice}
                  showEmoji={!question.questionConfiguration?.disableEmojiOnSlider}
                  question={question}
                />
              ))}
            </ul>
            <ul className='c-result-group__meta'>
              {choices[0].nrVotedNeutralPositive > 0 && (
                <li>
                  <strong>{`${perc(choices[0].nrVotedNeutralPositive, countAnswered)}%`}</strong> voted neutral to
                  positively about this
                </li>
              )}
            </ul>
          </div>
        </div>

        <QuestionFooter answered={countAnswered} skipped={skipSeen.skipCount} viewed={skipSeen.seenCount} />
      </div>
    </div>
  );
}

SliderPreview.propTypes = {
  question: PropTypes.shape({
    questionId: PropTypes.string.isRequired,
    countAnswered: PropTypes.number,
    choices: PropTypes.array,
    resource: PropTypes.string,
    skipSeen: PropTypes.shape({
      seenCount: PropTypes.number,
      skipCount: PropTypes.number,
    }),
  }).isRequired,
};

export default SliderPreview;
